const ArkaIframe = ({url}) => {

    return (
        url
    );
};

export { ArkaIframe };